

exports.__esModule = true;
exports.formatQuantity = formatQuantity;

var _locale = require('./locale');

var _currency = require('./currency');

// format a quantity to add a thousand separator based on a locality
function formatQuantity(quantity) {
    var _ref = _locale.$locale.metadata || {},
        _ref$number = _ref.number,
        numberConfig = _ref$number === undefined ? {} : _ref$number;

    var dot = '';
    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;

    return (0, _currency.roundingAndSeparators)(quantity.toString(), _locale.$locale, { decimalPlaces: 0, dot: dot, comma: comma });
}

_locale.$locale;

_currency.roundingAndSeparators;


//////////////////
// WEBPACK FOOTER
// ./components/squid/dist/locale/quantity.js
// module id = ./components/squid/dist/locale/quantity.js
// module chunks = 1